/**
 * RESPONSIBILITY: define the legal flag codes. One character each.
 *
 * The base64url alphabet — A–Z, a–z, 0–9, '-', '_'. Exactly 64 characters, which is
 * why the flag limit is 64: one character, one flag, no arithmetic.
 *
 * Every one of these is URL-safe with no escaping, so `?flag=A4b` survives being
 * pasted, copied and mailed. Characters like % & # + = ? / are excluded on purpose:
 * '%' in particular is the percent-escape prefix and would arrive mangled.
 */
export const FLAG_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

export const MAX_FLAGS = FLAG_ALPHABET.length;   // 64

export const isLegalCode = (code: string): boolean =>
  code.length === 1 && FLAG_ALPHABET.includes(code);

/**
 * Codes are CASE-SENSITIVE: 'a' and 'A' are different flags. That is what makes 64
 * fit in one character, but it means a code should be copied, not dictated —
 * O/0 and l/I are easy to confuse out loud.
 */
export const describeAlphabet = (): string =>
  `${MAX_FLAGS} single-character codes: A-Z a-z 0-9 - _ (case-sensitive)`;
